import React from "react";
import { TableBody, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { makeKey } from "../../../../../../utils/helpers";
import { ResponsiveTableCell } from "../../../../../../components/layout/responsive-table/responsive-table-cell.component";
import { ResponsiveTable } from "../../../../../../components/layout/responsive-table/responsive-table.component";
import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";

import { SearchProductsTableRow } from "../search-products-table-row/search-products-table-row.component";
import { SearchProductsTableProps } from "./search-products-table.props";

export const SearchProductsTable = withShowIf((props: SearchProductsTableProps) => {
  const useStyles = makeStyles({
    table: {
      minWidth: 500,
    },
  });
  const classes = useStyles();

  if (!props.products.length) return null;

  return (
    <TableContainer>
      <ResponsiveTable className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <ResponsiveTableCell />
            <ResponsiveTableCell>Item Code</ResponsiveTableCell>
            <ResponsiveTableCell align="left">Item Desc.</ResponsiveTableCell>
            <ResponsiveTableCell align="left">SubClass</ResponsiveTableCell>
            <ResponsiveTableCell align="left">Reg. Price</ResponsiveTableCell>
            <ResponsiveTableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {props.products.map((product, index) => (
            <SearchProductsTableRow
              key={makeKey("product", index)}
              handleClickProduct={props.handleClickProduct}
              product={product}
            />
          ))}
        </TableBody>
      </ResponsiveTable>
    </TableContainer>
  );
});
